import React from 'react';
import PropTypes from 'prop-types';
import MLButton from '../../../MLButton';

import s from '../LinkReefDialog.module.css';

const InstructorHeader = ({ handleGetReefCourseList, handleCreateCourse }) => (
  <header className={s.header}>
    <div
      className={s.instructorHeader_top}
      data-test-id="reef-instructor-header"
    >
      <div className={s.image} data-test-id="reef-cloud-image" />
      <div className={s.instructorHeader_top_links}>
        <MLButton
          btnType="primary"
          className={s.linkBtn}
          onClick={handleCreateCourse}
          testId="reef-instructor-header-new-course-button"
        >
          + New Course
        </MLButton>
        <MLButton
          btnType="secondary"
          className={s.linkBtn}
          onClick={handleGetReefCourseList}
          testId="reef-instructor-header-refresh-button"
        >
          Refresh list
        </MLButton>
      </div>
    </div>
    <div className={s.courseSelectorText}>
      Select an iClicker course that you want to link
    </div>
  </header>
);

InstructorHeader.propTypes = {
  handleGetReefCourseList: PropTypes.func.isRequired,
  handleCreateCourse: PropTypes.func.isRequired,
};

export default InstructorHeader;
